module.exports = __webpack_public_path__ + "assets/img/tgsm6.93cc95aa.png";